<script setup>
import { computed } from "vue"
import { useNow } from '@vueuse/core'

const now = useNow({ interval: 60 * 1000 });

const time = computed(() => now.value.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit', hour12: true }))
const dayName = computed(() => now.value.toLocaleDateString([], { weekday: 'long' }))
const fullDate = computed(() => now.value.toLocaleDateString(['en-US'], { year: 'numeric', month: 'long', day: 'numeric' }))
const timeOfDay = computed(() => {
  const text = now.value.toLocaleString([], { dayPeriod: 'short'}).replace('in the', '').replace('at ', '').trim()
  const localePeriod = text.charAt(0).toUpperCase() + text.slice(1);
  return localePeriod
})

</script>

<template>
  <div class="grid text-center gap-y-6 auto-rows-auto mt-4">
    <div class="px-4"><h2 class="font-bold text-[5rem] leading-none">{{ dayName }}</h2></div>
    <div class="px-4"><h3 class="text-[4rem] leading-none">{{ timeOfDay }}</h3></div>
    <div class="px-4"><h1 class="font-bold text-8xl leading-none">{{ time }}</h1></div>
    <div class="px-4 mb-4"><h3 class="text-[4rem] leading-none">{{ fullDate }}</h3></div>
  </div>
</template>

<style scoped>
</style>